.track {
  position: fixed;
  inset: 0 0 auto;
  z-index: 2147483647;
  height: 3px;
  pointer-events: none;
}

.bar {
  height: 100%;
  background: var(--color-primary);
  transform-origin: left;

  &[data-phase="running"] {
    // Eases towards the end without reaching it, until the navigation finishes.
    animation: trickle 8s cubic-bezier(0.1, 0.7, 0.2, 1) forwards;
  }

  &[data-phase="finishing"] {
    transform: scaleX(1);
    opacity: 0;
    transition:
      transform 150ms ease-out,
      opacity 200ms ease-out 100ms;
  }
}

@keyframes trickle {
  from {
    transform: scaleX(0.08);
  }
  to {
    transform: scaleX(0.92);
  }
}

@media (prefers-reduced-motion: reduce) {
  .bar[data-phase="running"] {
    animation: none;
    transform: scaleX(0.6);
  }
}
